import React from "react";
import { Bar } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";

const PlayerProfileBarChartAnthro = (props) => {
  const {
    playervalue,
    groupvalue,
    chartName,
    name,
    rank,
    width,
    isPlayerProfileChart,
  } = props;

  // Sample data
  const data = {
    labels: [name, "Group Average"],
    datasets: [
      {
        label: chartName,
        data: [playervalue, groupvalue],
        backgroundColor: ["rgb(186 28 28 / 87%)", "rgb(32 66 132)"],
        borderColor: ["rgb(186 28 28 / 87%)", "rgb(32 66 132)"],
        borderWidth: 1,
        barThickness: 25,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        beginAtZero: true,
        barThickness: 6,
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    responsive: true,
  };

  const getContainerStyle = () => {
    if (isPlayerProfileChart) {
      return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      };
    } else {
      return { width: "100%" };
    }
  };

  return (
    <div style={getContainerStyle()}>
      <Box mt={2} mb={2} sx={{ maxWidth: "600px", width: "100%" }}>
        <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
          <div style={{ textAlign: "center" }}>
            <h3>{chartName}</h3>
          </div>
          <Bar data={data} options={options} width={"450px"} height={"180px"} />
          <div style={{ textAlign: "center" }}>
            <h3>Rank : {rank}</h3>
          </div>
        </Paper>
      </Box>
    </div>
  );
};

export default PlayerProfileBarChartAnthro;
